import { ValidationType } from '../utils/validators';

import Field, { FieldDataType } from './Field';
import { Section } from './index';
import { FIXTURES_APPLIANCES_PERSONAL_PROPERTY } from '../constants';

export default class FixturesAppliancesPersonalPropertySection extends Section {
  constructor(args) {
    super(args);

    this.setIndexedFieldTypes([
      new Field({
        fieldName: FIXTURES_APPLIANCES_PERSONAL_PROPERTY.FIELD_NAME.IS_ENABLED,
        dataType: FieldDataType.boolean,
        enteredValue: true,
        validation: ValidationType.BooleanValidator,
      }),
      new Field({
        fieldName: FIXTURES_APPLIANCES_PERSONAL_PROPERTY.FIELD_NAME.NAME,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
      new Field({
        fieldName: FIXTURES_APPLIANCES_PERSONAL_PROPERTY.FIELD_NAME.COST,
        enteredValue: '',
        dataType: FieldDataType.currency,
        validation: ValidationType.CurrencyValidator,
      }),
    ]);
  }
}
